export function groupBy<T>(array: T[], keyFn: (key: T) => string): Record<string, T[]> {
  return array.reduce((acc, item) => {
    const groupAsKey = keyFn(item);
    return {
      ...acc,
      [groupAsKey]: [...(acc[groupAsKey] || []), item],
    };
  }, {} as Record<string, T[]>);
}
